import React from 'react'
import "./cosmetology.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Cosmetology() {

   return (
      <>
         <div className="container">
            <CustomTitle title="صفحة التجميل" />

            <h2 className='main-header mt-5 pt-5'>Cosmetology Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
